module.exports = __webpack_public_path__ + "img/Mescyt.7a8a2140.svg";